module.exports = __webpack_public_path__ + "static/media/mohamed tammam.ce2a36ba.webp";